module.exports = __webpack_public_path__ + "images/signal_1.b33cc5d9f662973ce45888273dbb8361.png";